// extracted by mini-css-extract-plugin
export default {"card_style":"style_card_style__awrP+"};